import React from "react";
import { Modal, Button } from "react-bootstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as alertActions from "../../redux/actions/alertAction";

import { myUtilities } from "../../Utils";

const AlertTxnLimit = (props) => {
  console.log('AlertTxnLimit',props.alert);
  const onOkPressed = () =>  {
    props.backButtonOnClick(props.paymentData, props.invData);
    props.alertActions.hideTxnLimitALert();
  }
  return (
    
    <Modal
      show={props.alert.showTxnLimitAlert}
      onHide={onOkPressed}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>
          {myUtilities.accountSpecificLanguage("Alert.Header", "Alert!" )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
      {myUtilities.accountSpecificLanguagePlaceholders(
              props.alert.id,
              props.alert.message,
              props.alert.value !== undefined ? props.alert.value : {}
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="primary"
          onClick={onOkPressed}
        >
          {myUtilities.accountSpecificLanguage("AlertDialog.Ok", "Ok" )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  alert: state.commonAlerts,
});

const mapDispatchToProps = (dispatch) => ({
  alertActions: bindActionCreators(alertActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AlertTxnLimit);
